import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';

export const getGridState = createSelector(getDragonflySharedState, (state) => state.paginator);

export const getItemsNumber = createSelector(getGridState, ({ itemsNumber }) => itemsNumber);

export const getItemsPerPage = createSelector(getGridState, ({ itemsPerPage }) => itemsPerPage);

export const getSelectedSortField = createSelector(getGridState, ({ selectedSortField }) => selectedSortField);

export const getSelectedOrder = createSelector(getGridState, ({ selectedOrder }) => selectedOrder);

export const getPageIndex = createSelector(getGridState, ({ paginator }) => paginator.pageIndex);

export const getTotalResultPages = createSelector(getGridState, ({ totalPages }) => totalPages);

export const getSortFieldOptions = createSelector(getGridState, ({ sortFieldOptions }) => sortFieldOptions);

export const getOrderFieldOptions = createSelector(getGridState, ({ orderFieldOptions }) => orderFieldOptions);
